import { useUser } from 'context/userContext';
import { ROLE } from 'utils/constants';
import GlobalAdminSync from './GlobalAdminSync/GlobalAdminSync';
import PracticeAdminSync from './PracticeAdminSync/PracticeAdminSync';

const SyncPage = () => {
  const {
    user: { currentClinicUserRole },
  } = useUser();

  const role = currentClinicUserRole?.role ?? '';

  return (
    <div
      className="py-2.4 pl-3 pr-4 text-14 leading-[2.1rem]"
      data-testid="page-sync"
    >
      <h3 className="text-24 font-bold leading-[3.6rem]">Sync</h3>
      {role === ROLE.GLOBAL_ADMIN && <GlobalAdminSync />}
      {[ROLE.GROUP_ADMIN, ROLE.PRACTICE_ADMIN].includes(role) && (
        <PracticeAdminSync />
      )}
    </div>
  );
};

export default SyncPage;
